<div class="page-padding"><fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details></div>
